import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommonService} from '../../../core/service/common.service';
import {MasterService} from '../../../core/service/master.service';
import {EVENT_SHUBETSU_EXCEPT_OTHER_OBJECT} from '../../constants';

@Component({
  selector: 'app-saizai-saiketsu-dialog',
  templateUrl: './anken-sub-dialog.component.html',
  styleUrls: ['./anken-sub-dialog.component.scss', '../../layout/layout.component.scss']
})
export class AnkenSubDialogComponent implements OnInit {
  public meisai: any = {};
  public shubetsu = '';
  title = '';
  eventShubetsuExceptOtherObj = EVENT_SHUBETSU_EXCEPT_OTHER_OBJECT;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public commonService: CommonService,
              public masterService: MasterService,
              public matDialogRef: MatDialogRef<AnkenSubDialogComponent>,) { }

  /**
   *
   */
  ngOnInit(): void {
    this.meisai = this.data.meisai;
    this.shubetsu = this.data.shubetsu;
    switch (this.shubetsu) {
      case this.eventShubetsuExceptOtherObj.saizai.eventShubetsu:
      case 'saizaiNittei':
        this.title = '採材日程追加・修正';
        break;
      case this.eventShubetsuExceptOtherObj.saiketsu.eventShubetsu:
      case 'saiketsuNittei':
        this.title = '採血追加・修正';
        break;
      case this.eventShubetsuExceptOtherObj.vaccine.eventShubetsu:
      case 'vaccineProgram':
        this.title = 'ワクチンプログラム追加・修正';
        break;
      case this.eventShubetsuExceptOtherObj.debeak.eventShubetsu:
      case 'debeakNittei':
        this.title = 'デビーク追加・修正';
        break;
    }
  }
}
